import React, { useContext, useMemo, useState } from "react";
import { CorporateContext } from "./CorporateContext";
import { ICorporateContextProps } from "./CorporateContextInterfaces";
import { CorporationsEntity } from "entities/Corporations/CorporationsEntity";
import { UserContext } from "contexts/UserContext/UserContext";
import { UsersEntity } from "entities/Users/UsersEntity";

export const CorporateContextProvider: React.FC<ICorporateContextProps> = ({ children }) => {
    const [isFullscreenActive, setIsFullscreenActive] = useState(false);
    const {
        corporations,
        millsWithNoDivision,
        loading: isLoadingCorporationsAndDivisions,
        refetch: refreshCorporationsAndDivisions,
    } = CorporationsEntity.GetMenuCorporateDivisionsRegionsMills();
    const divisions = useMemo(() => corporations[0]?.divisions || [], [corporations]);
    const rcaEnabled = useMemo(() => corporations[0]?.rca_enabled, [corporations]);
    const { user_id } = useContext(UserContext);
    const {
        currentUser,
        enabledNotifications,
        enabledNotificationsIds,
        loading: isLoadingCurrentUser,
        refetch: refreshCurrentUser,
    } = UsersEntity.GetCurrentUser(user_id || 0);

    const handleSetIsFullscreenActive = (value: boolean) => {
        setIsFullscreenActive(value);
    };

    const providerValue = {
        enabledNotifications,
        enabledNotificationsIds,
        rcaEnabled,
        isFullscreenActive,
        handleSetIsFullscreenActive,
        divisions,
        corporations,
        millsWithNoDivision,
        currentUser,
        isLoadingCurrentUser,
        isLoadingCorporationsAndDivisions,
        refreshCorporationsAndDivisions,
        refreshCurrentUser,
    };

    return <CorporateContext.Provider value={providerValue}>{children}</CorporateContext.Provider>;
};
